import { createStore, applyMiddleware } from 'redux';
import reducer from '../reducers'

import api from "../middlewares/api.js";
import randomId from "../middlewares/randomId.js";
import thunk from 'redux-thunk';
import logger from 'redux-logger'

const enhancer = applyMiddleware(
  thunk,
  api,
  randomId
);

const store = createStore(
  reducer,
  enhancer
);

// window.store = store;

export default store


// WEBPACK FOOTER //
// ./src/store/index.js